import React from "react";
import { Badge } from "@/components/ui/badge";
import {
    PROPOSAL_STATUS_META,
    getProposalStatusBadgeClass,
} from "@/config/constants";

export function ProposalStatusBadge({ value, size = "sm", withDot = true, className = "" }) {
    const meta = PROPOSAL_STATUS_META[value];
    const cls = getProposalStatusBadgeClass(value);
    const sizeCls =
        size === "lg" ? "text-sm px-2.5 py-0.5" : "text-[11px] px-2 py-0.5";
    return (
        <Badge
            variant="outline"
            className={`gap-1.5 font-medium ${sizeCls} ${cls} ${className}`}
            data-testid={`proposal-status-badge-${value}`}
        >
            {withDot && (
                <span
                    className={`inline-block h-1.5 w-1.5 rounded-full ${meta?.dotClass || "bg-muted-foreground"}`}
                    aria-hidden="true"
                />
            )}
            {meta?.label || value}
        </Badge>
    );
}

export default ProposalStatusBadge;
